import { Controller } from "@hotwired/stimulus";

const ACTIVE = ["border-cta", "bg-cta", "text-white"];
const IDLE = ["border-line", "bg-card", "text-ink-muted", "hover:text-ink"];

// A <details> menu keeps itself open when you click elsewhere on the page, which reads
// as broken sitting next to controls that dismiss.
//
// It also has to restate its own choice. These filters live outside the results frame,
// so that typing in the search box beside them never loses focus, which means a submit
// swaps the results and leaves this button showing whatever the server last rendered.
export default class extends Controller {
  static targets = ["summary", "label"];
  static values = { label: String };

  connect() {
    this.closeOnOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.element.open = false;
    };
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.element.open = false;
    };

    document.addEventListener("click", this.closeOnOutsideClick);
    document.addEventListener("keydown", this.closeOnEscape);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick);
    document.removeEventListener("keydown", this.closeOnEscape);
  }

  choose() {
    const checked = this.element.querySelector("input[type=radio]:checked");
    const chosen = checked && checked.value !== "";
    const option = checked ? checked.closest("label").textContent.trim() : "";

    // Without a prefix the button is the choice itself, which is how a control whose
    // default is already a choice reads, like Registered.
    if (this.labelValue) {
      this.labelTarget.textContent = chosen ? `${this.labelValue}: ${option}` : this.labelValue;
    } else {
      this.labelTarget.textContent = option;
    }

    ACTIVE.forEach((token) => this.summaryTarget.classList.toggle(token, chosen));
    IDLE.forEach((token) => this.summaryTarget.classList.toggle(token, !chosen));

    this.element.open = false;
  }
}
